export default __webpack_public_path__ + "ccc61b5fc51976e997d21912d6ad8b14.svg";